/* Hunters Sports interactions. Progressive enhancement: without JS every page still shows its products,
   the ball sits in the hero and the quote form works. GSAP + ScrollTrigger are optional (hub ball story). */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const root = $('.sp');
  if (!root) return;
  const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('is-js');

  // 1. Reveal on scroll (staggered by --i within a group).
  const io = 'IntersectionObserver' in window && !still && new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
  }), { rootMargin: '0px 0px -8% 0px' });
  $$('[data-reveal]').forEach((el, i) => io ? io.observe(el) : el.classList.add('is-in'));

  // 2. Colour dots on product tiles: swap the tile's front (and back) image to that colourway.
  $$('[data-sp-card]').forEach(card => {
    const [front, back] = $$('.sp-card__img img', card);
    $$('.sp-dot', card).forEach(dot => dot.addEventListener('click', e => {
      e.preventDefault();
      front.src = dot.dataset.src;
      if (back && dot.dataset.back) back.src = dot.dataset.back;
      $$('.sp-dot', card).forEach(d => d.setAttribute('aria-pressed', d === dot));
      const a = $('a', card);
      if (a) a.href = a.href.split('&c=')[0].split('?c=')[0] + (a.href.includes('?d=') ? '&c=' : '?c=') + dot.dataset.cw;
    }));
  });

  // 3. Hub "your colours" showcase: crossfade the kit to the tapped colourway.
  $$('[data-sp-showcase]').forEach(box => {
    const imgs = $$('img[data-cw]', box), name = $('.sp-sw-name', box);
    $$('.sp-sw button', box).forEach(b => b.addEventListener('click', () => {
      imgs.forEach(i => i.classList.toggle('is-off', i.dataset.cw !== b.dataset.cw));
      $$('.sp-sw button', box).forEach(x => x.setAttribute('aria-pressed', x === b));
      name.textContent = b.getAttribute('aria-label');
    }));
  });

  // 4. Product design studio: every design shown plainly (no style filters), then colours.
  const dataEl = $('#sp-data');
  if (dataEl) {
    const D = JSON.parse(dataEl.textContent);
    const url = f => D.base + f;
    const byDesign = new Map();
    D.designs.forEach(r => { if (!byDesign.has(r.design)) byDesign.set(r.design, []); byDesign.get(r.design).push(r); });
    const q = new URLSearchParams(location.search);
    const st = D.start || [[...byDesign.keys()][0]];
    const cur = { d: byDesign.has(q.get('d')) ? q.get('d') : st[0], c: q.get('c') || st[1], v: 'front' };
    const stage = $('#sp-stage'), grid = $('#sp-designs'), sw = $('#sp-swatches');
    const row = () => byDesign.get(cur.d).find(r => r.colourway === cur.c) || byDesign.get(cur.d)[0];
    const render = () => {
      const r = row();
      cur.c = r.colourway;
      const src = url(r.files[cur.v] || Object.values(r.files)[0]);
      if (!stage.src.endsWith(src.split('/').pop())) {
        stage.classList.add('is-swap');
        const pre = new Image();
        pre.onload = () => { stage.src = src; stage.classList.remove('is-swap'); };
        pre.src = src;
      }
      stage.alt = `${D.title}, ${r.name} design, ${r.colourway_name}, ${cur.v} view`;
      $$('.sp-design', grid).forEach(b => b.setAttribute('aria-pressed', b.dataset.d === cur.d));
      sw.innerHTML = '';
      byDesign.get(cur.d).forEach(x => {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'sp-dot sp-dot--lg';
        b.style.setProperty('--a', D.cw[x.colourway][0]); b.style.setProperty('--b', D.cw[x.colourway][1]);
        b.title = x.colourway_name; b.setAttribute('aria-label', x.colourway_name);
        b.setAttribute('aria-pressed', x.colourway === cur.c);
        b.onclick = () => { cur.c = x.colourway; render(); };
        sw.append(b);
      });
      $$('[data-sp-fill="design"]').forEach(i => i.value = `${D.title} ${r.name} (${r.design})`);
      $$('[data-sp-fill="colours"]').forEach(i => i.value = r.colourway_name);
      $$('[data-sp-summary]').forEach(s => s.textContent = `${D.title}: ${r.name} design, ${r.colourway_name}`);
      history.replaceState(null, '', `?d=${r.design}&c=${r.colourway}`);
    };
    byDesign.forEach((rows, d) => {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'sp-design'; b.dataset.d = d; b.setAttribute('aria-label', `${rows[0].name} design`);
      b.innerHTML = `<img loading="lazy" src="${url(Object.values(rows[0].files)[0])}" alt=""><small>${rows[0].name}</small>`;
      b.onclick = () => { cur.d = d; render(); };
      grid.append(b);
    });
    $$('[data-sp-view]').forEach(b => b.onclick = () => {
      cur.v = b.dataset.spView;
      $$('[data-sp-view]').forEach(x => x.setAttribute('aria-pressed', x === b));
      render();
    });
    render();
  }

  // 5. Quote form: step 1 = what (low effort), step 2 = who. Validate on blur, focus first error.
  $$('[data-sp-quote]').forEach(form => {
    const s1 = $('[data-step="1"]', form), s2 = $('[data-step="2"]', form), next = $('[data-sp-next]', form);
    const check = el => {
      const err = $(`#${el.id}-err`);
      const bad = !el.checkValidity();
      if (err) err.textContent = bad ? (el.dataset.msg || 'Please fill this in.') : '';
      el.setAttribute('aria-invalid', bad);
      return !bad;
    };
    $$('input, select, textarea', form).forEach(el => el.addEventListener('blur', () => el.value && check(el)));
    const valid = scope => {
      const bad = $$('input, select, textarea', scope).filter(el => !check(el));
      if (bad.length) bad[0].focus();
      return !bad.length;
    };
    // Design: the design shown, design it for us, match our current kit, or the club's own artwork
    const help = $('[data-sp-start-help]', form), summary = $('[data-sp-summary]', form);
    $$('input[name="contact[Start from]"]', form).forEach(r => r.addEventListener('change', () => {
      help.textContent = r.dataset.help;
      if (summary) summary.hidden = r.value !== 'This design';
    }));
    // Sport: show only that sport's items, none until a sport is picked (no JS: every list shows). Ticked items in a hidden list stay ticked.
    const showSport = () => {
      const v = ($('input[name="contact[Sport]"]:checked', form) || {}).value;
      $$('.sp-items', form).forEach(g => g.hidden = g.dataset.sport !== v);
      const hint = $('[data-sp-items-hint]', form);
      if (hint) hint.hidden = !!v && v !== 'Another sport';
    };
    $$('input[name="contact[Sport]"]', form).forEach(r => r.addEventListener('change', showSport));
    showSport();
    const submit = $('[type=submit]', form), back = $('[data-sp-back]', form);
    if (next && s2) {
      const step = two => {
        s1.hidden = two; s2.hidden = !two; next.hidden = two; submit.hidden = !two; back.hidden = !two;
        $$('[data-req]', s2).forEach(el => el.required = two);
        (two ? $('input', s2) : $('input', s1)).focus();
        form.scrollIntoView({ block: 'start', behavior: still ? 'auto' : 'smooth' });
      };
      $$('[required]', s2).forEach(el => { el.dataset.req = ''; el.required = false; });
      s2.hidden = true; submit.hidden = true;
      next.onclick = () => valid(s1) && step(true);
      back.onclick = () => step(false);
    }
    form.addEventListener('submit', e => {
      if (!valid(form)) return e.preventDefault();
      // one line per group in the inbox ("Items: Match jersey, Match shorts") instead of one line per tick
      const groups = {};
      $$('[data-sp-join]', form).forEach(c => {
        (groups[c.dataset.spJoin] ||= []).push(...(c.checked ? [c.dataset.v] : []));
        c.disabled = true;
      });
      Object.entries(groups).forEach(([k, v]) => {
        const h = Object.assign(document.createElement('input'), { type: 'hidden', name: `contact[${k}]`, value: [...new Set(v)].join(', ') || 'None ticked' });
        form.append(h);
      });
      submit.disabled = true;
    });
  });

  // 6. Hub story: the Hunters ball leaves the hero and travels to each [data-sp-spot] as the visitor
  //    scrolls, rolling (rotation from distance) with a small arc. Positions come from the spots, so the
  //    layout owns the path; ScrollTrigger supplies scroll + refresh, gsap.quickTo smooths it.
  const ball = $('[data-sp-ball]'), spots = $$('[data-sp-spot]');
  if (ball && spots.length > 1 && !still && matchMedia('(min-width: 768px)').matches && window.gsap && window.ScrollTrigger) {  // no ball on phones: hidden in sports.css
    gsap.registerPlugin(ScrollTrigger);
    const layer = document.createElement('div');
    layer.className = 'sp-ball-layer';
    layer.setAttribute('aria-hidden', 'true');
    root.append(layer);
    layer.append(ball);
    ball.classList.add('sp-ball');
    const W = 200;  // .sp-ball-layer .sp-ball width
    let P = [], legs = [];
    const measure = () => {
      const o = root.getBoundingClientRect(), vh = innerHeight, sy = scrollY;
      // live theme: an app wrapper can hide the content for a frame during a refresh; a zero-size read
      // would send the ball to the corner, so keep the last good measurement instead
      if (!o.width || spots.some(el => !el.getBoundingClientRect().width)) return false;
      P = [];
      spots.forEach((el, i) => {
        const r = el.getBoundingClientRect();
        const p = { x: r.left - o.left + r.width / 2, y: r.top - o.top + r.height / 2, k: r.width / W, rot: 0 };
        if (i) {  // roll: one turn per circumference travelled, clockwise when heading right
          const a = P[i - 1];
          // roll by distance, capped (a pass, not a spin), in whole turns so the H always lands upright
          const turn = Math.hypot(p.x - a.x, p.y - a.y) / (Math.PI * W * (a.k + p.k) / 2);
          p.rot = a.rot + 360 * Math.max(1, Math.min(2, Math.round(turn))) * (p.x < a.x ? -1 : 1);
        }
        P.push(p);
      });
      // leg i runs while spot i's top moves from data-from to data-to (fractions of the viewport height)
      const end = document.documentElement.scrollHeight - vh;  // a leg must finish before the page runs out
      legs = spots.map(el => {
        const top = el.getBoundingClientRect().top + sy;
        const b = Math.min(top - vh * +(el.dataset.to || .55), end);
        return { a: Math.min(top - vh * +(el.dataset.from || .9), b - vh * .25), b };
      });
    };
    const ease = gsap.parseEase('power1.inOut');
    const qx = gsap.quickTo(ball, 'x', { duration: .45, ease: 'power3' }), qy = gsap.quickTo(ball, 'y', { duration: .45, ease: 'power3' });
    const qr = gsap.quickTo(ball, 'rotation', { duration: .6, ease: 'power3' }), qsx = gsap.quickTo(ball, 'scaleX', { duration: .45, ease: 'power3' }), qsy = gsap.quickTo(ball, 'scaleY', { duration: .45, ease: 'power3' });  // quickTo ignores the 'scale' alias
    const place = (s, now) => {
      let i = 0;
      while (i + 1 < P.length && s >= legs[i + 1].a) i++;
      let p = P[i], arc = 0;
      if (i > 0 && s < legs[i].b) {  // in transit from spot i-1 to spot i
        const t = ease((s - legs[i].a) / (legs[i].b - legs[i].a)), a = P[i - 1], b = P[i];
        p = { x: a.x + (b.x - a.x) * t, y: a.y + (b.y - a.y) * t, k: a.k + (b.k - a.k) * t, rot: a.rot + (b.rot - a.rot) * t };
        arc = Math.sin(Math.PI * t) * Math.min(160, Math.abs(b.y - a.y) * .12 + 40);
      }
      const v = [p.x - W / 2, p.y - W / 2 - arc, p.rot, p.k];
      if (now) gsap.set(ball, { x: v[0], y: v[1], rotation: v[2], scale: v[3] });
      else { qx(v[0]); qy(v[1]); qr(v[2]); qsx(v[3]); qsy(v[3]); }
    };
    ScrollTrigger.create({
      trigger: root, start: 'top bottom', end: 'bottom top',
      onRefresh: () => { if (measure() !== false || P.length) place(scrollY, true); },
      onUpdate: () => P.length && place(scrollY),
    });
    if (measure() !== false) place(scrollY, true);
    // fonts and lazy images move the spots after load: re-measure whenever the page's height changes
    let t;
    new ResizeObserver(() => { clearTimeout(t); t = setTimeout(() => ScrollTrigger.refresh(), 120); }).observe(root);
  }
})();
